// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import clearInputIcon from "@/assets/icons/aop/clear-input.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ClearInputIconProps = Omit<IconProps, "name">;

export function ClearInputIcon(props: ClearInputIconProps): React.ReactNode {
  return <Icon name={clearInputIcon} {...props} />;
}
